//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../AME/AME.AMEBaseNode.js";
import "../no/ugmath.js";
let d=[[],[[["cabinetNode","state"],"SetCabinetState",{},2,0],[["product3DModelFileName","location","parentEngObj","receptacleObject"],"PlaceProductInActiveCabinet",{},4,0],[["location","engObjects","receptacleObject","distance","placementType","placementAngle"],"PlaceProductsInActiveCabinet",{},6,0]],[]];
SPLM.AME.CabinetRoot = class extends SPLM.AME.AMEBaseNode{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.CabinetRoot";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.CabinetRoot.CabinetState = Object.freeze({
    "Active" : "Active", "Inactive" : "Inactive"});

export default SPLM;